export default "__VITE_ASSET__b2615ad9__"